module.exports = __webpack_public_path__ + "media/images/new_home/press-large-image-629ff4ce1690227f668c9e58ebf87244.png";